import { RodRequestStatusCode } from '@bechtel/types';
import { t } from '@lingui/macro';
import { RodRequestItemTab } from './types';

export const rodRequestItemTabList: RodRequestItemTab[] = [
  {
    label: t`Open`,
    value: [RodRequestStatusCode.REQUESTED, RodRequestStatusCode.PARTIAL_ISSUED, RodRequestStatusCode.EXPIRED],
  },
  {
    label: t`Issued`,
    value: [RodRequestStatusCode.ISSUED, RodRequestStatusCode.PARTIAL_ISSUED, RodRequestStatusCode.EXPIRED],
  },
  { label: t`Closed`, value: [RodRequestStatusCode.CLOSED] },
];
